export default __webpack_public_path__ + "static/media/gridImage15.6f0fd536.png";